import { styled } from '@mui/material';

import { CoreAlert } from '@youscience/core';

export const StyledAlert = styled(CoreAlert, {
  shouldForwardProp: (prop) => prop !== 'expanded',
})<{ expanded?: boolean }>(({ theme, expanded }) => {
  const styles = {
    color: `${theme.palette.common.white}`,
    borderRadius: '4px',
  };

  return expanded ? { ...styles, flexWrap: 'wrap' } : { ...styles, minWidth: '52px' };
});
